import {Service} from './service'

export class WithdrawUSDTService extends Service {
  createWithdrawalUSDTRequest (params) {
    return this._apiRequestBuilder
      .withdrawalUsdt()
      .urlSegment('withdrawal_usdt_pending')
      .setParams(params)
      .post()
  }

  getWithdrawalUSDTRequestInfo (params) {
    return this._apiRequestBuilder
      .withdrawalUsdt()
      .urlSegment('get_withdrawal_delayed_usdt_by_internal_id')
      .setParams(params)
      .post()
  }

  applyWithdrawalUSDTRequest (params) {
    return this._apiRequestBuilder
      .withdrawalUsdt()
      .urlSegment('apply_withdrawal_usdt')
      .setParams(params)
      .post()
  }

  cancelWithdrawalUSDTRequest (params) {
    return this._apiRequestBuilder
      .withdrawalUsdt()
      .urlSegment('cancel_withdrawal_usdt')
      .setParams(params)
      .post()
  }

  getSubWallets (params) {
    return this._apiRequestBuilder
    .withdrawalUsdt()
    .urlSegment('get_subwallets')
    .setParams(params)
    .post()
  }

  getSubWalletsClients (params) {
    return this._apiRequestBuilder
    .withdrawalUsdt()
    .urlSegment('subwallet_client_list')
    .addQuery('user_id', params.user_id)
    .get()
  }

  changeClietnBySubwallet (params) {
    return this._apiRequestBuilder
    .withdrawalUsdt()
    .urlSegment('change_client_name')
    .setParams(params)
    .put()
  }

  changeDesciptionBySubwallet (params) {
    return this._apiRequestBuilder
    .withdrawalUsdt()
    .urlSegment('change_description')
    .setParams(params)
    .put()
  }

  getSubWalletsDescriptions (params) {
    return this._apiRequestBuilder
    .withdrawalUsdt()
    .urlSegment('subwallet_description_list')
    .addQuery('user_id', params.user_id)
    .get()
  }

  transfertToWallet (params) {
    return this._apiRequestBuilder
    .withdrawalUsdt()
    .urlSegment('transfer_asset_subwallet')
    .setParams(params)
    .put()
  }

  deleteSubWallet (params) {
    return this._apiRequestBuilder
    .withdrawalUsdt()
    .urlSegment('deactivate_subwallet')
    .setParams(params)
    .put()
  }

  createSubWallet (params) {
    return this._apiRequestBuilder
    .withdrawalUsdt()
    .urlSegment('create_subwallet')
    .setParams(params)
    .post()
  }

  getHash (params) {
    return this._apiRequestBuilder
    .withdrawalUsdt()
    .urlSegment('withdrawal_usdt')
    .setParams(params)
    .post()
  }
}

export const withdrawUSDTService = new WithdrawUSDTService()



// WEBPACK FOOTER //
// ./src/js/services/withdraw_usdt.service.js